import { IState } from '../../store';
import { ECpdDraftStatus } from '../../types/cpd/cpd';

export const selectIsCpdAvailable = (state: IState): boolean => state.cpd?.isCpdAvailable ?? false;

export const selectCpdDraftId = (state: IState): number | undefined => state.cpd?.cpdDraftId;

export const selectCpdDraftStatus = (state: IState): ECpdDraftStatus => {
  return state.cpd?.cpdDraftStatus ?? ECpdDraftStatus.init;
};
